import template from './countdownclock.tpl.html';
import controller from './countdownclock.controller';

export default function() {
    return {
        restrict: 'E',
        scope: false,
        controller: ['$scope', '$interval', controller],
        controllerAs: 'cctrl',
        bindToController: true,
        template: template
    };
}
